export const endpoint = "https://qbmedia.b-cdn.net/qbmedia/"

export const bizDetails = {
    name: "Refresh | ريفريش",
    description: "المشروبات الي رح يدمنها قلبك",
    socialBtns : {
        menu: "المنيو",
        call: "اتصل",
        wsp: "واتساب",
        ig: "انستاغرام",
        fb: "فيسبوك",
        website: "الموقع",
        app: "التطبيق",
        tiktok:"تيكتوك",
        mail: "مييل",
        review: "قييمني",
        meeting: "عين موعد"
    },
    saveBtnText: "ضيفني لجهات الاتصال",
    orderNowText: "أطلب وجبتك الأن",
    feedback: {
        customerServiceRating: "تقييم خدمة العملاء",
        ratingCopied: "تم نسخ التقييم إلى الحافظة. الرجاء لصقها في تقييمات Google.",
        rateExperience: "هل اعجبتك خدماتنا؟ هل تنصح بنا؟ قييم تجربتك.",
        feedbackPlaceholder: "أدخل ملاحظاتك هنا...",
        submitRating: "إرسال التقييم",
        thankYouPositive: "شكرًا لك على ملاحظاتك الإيجابية! هل يمكنك أخذ لحظة لمشاركة تقييمك على صفحة أعمالنا على Google؟ سيساعدنا ذلك كثيراً",
        copyRating: "نسخ التقييم",
        completeGoogleReview: "اكمال التقييم في Google",
        thankYouImprovement: "شكرًا لك على ملاحظاتك ومصداقيتك معنا. سنعمل بجد على التطوير والتحسين من ذاتنا."
    },
    modals: {
        scheduleAppointment: "تعيين موعد اونلاين",
        rateUs: "قييمنا بناء على تعاملك معنا"
    }
}

export const bizDetails_He = {
    name: "Refresh | ריפרש",
    description: "משקאות שיגרמו לך להתמכר",
    socialBtns : {
        menu: "התפריט",
        call: "שיחה",
        wsp: "וואטספ",
        ig: "אינסטגרם",
        fb: "פייסבוק",
        website: "האתר",
        app: "אפליקציה",
        tiktok:"טיקטוק",
        mail: "מייל",
        review: "דרג אותנו",
        meeting: "פגישה"
    },
    saveBtnText: "הוסף אותנו לאנשי קשר",
    orderNowText: "הזמן שירות עכשיו",
    feedback: {
        customerServiceRating: "דירוג שירות לקוחות",
        ratingCopied: "הדירוג הועתק ללוח. אנא הדבק אותו בביקורות Google.",
        rateExperience: "האם אהבת את השירותים שלנו? האם היית ממליץ עלינו? דרג את החוויה שלך.",
        feedbackPlaceholder: "הכנס את המשוב שלך כאן...",
        submitRating: "שלח דירוג",
        thankYouPositive: "תודה על המשוב החיובי שלך! האם תוכל לקחת רגע לשתף את הדירוג שלך בדף העסק שלנו ב-Google? זה יעזור לנו מאוד",
        copyRating: "העתק דירוג",
        completeGoogleReview: "השלם דירוג ב-Google",
        thankYouImprovement: "תודה על המשוב והכנות שלך איתנו. אנחנו נעבוד קשה לפתח ולשפר את עצמנו."
    },
    modals: {
        scheduleAppointment: "קביעת פגישה אונליין",
        rateUs: "דרג אותנו בהתבסס על הניסיון שלך"
    }
}

export const bizDetails_En = {
    name: "Refresh Drinks",
    description: "Steaks, Burgers and BBQ",
    socialBtns : {
        menu: "Menu",
        call: "Call Us",
        wsp: "Txt Us",
        ig: "Our IG",
        fb: "Our FB",
        website: "Website",
        app: "App",
        tiktok:"Tiktok",
        mail: "Mail",
        review: "Rate Us",
        meeting: "Meet Us"
    },
    saveBtnText: "Add Us To Contacts",
    orderNowText: "Order a Service",
    feedback: {
        customerServiceRating: "Customer Service Rating",
        ratingCopied: "Rating copied to clipboard. Please paste it in Google reviews.",
        rateExperience: "Did you like our services? Would you recommend us? Rate your experience.",
        feedbackPlaceholder: "Enter your feedback here...",
        submitRating: "Submit Rating",
        thankYouPositive: "Thank you for your positive feedback! Could you take a moment to share your rating on our Google business page? It would help us a lot",
        copyRating: "Copy Rating",
        completeGoogleReview: "Complete Google Review",
        thankYouImprovement: "Thank you for your feedback and honesty with us. We will work hard to develop and improve ourselves."
    },
    modals: {
        scheduleAppointment: "Schedule Online Appointment",
        rateUs: "Rate us based on your experience"
    }
}

export const contact = {
    name: "Refresh Drinks",
    phone: "972521234567",
    email: "info@qbmedia.co.il",
    website: "https://qbmedia.co.il/",
    app: "https://qbmedia.co.il/",
    ig:"refresh.reineh",
    fb:"profile.php?id=61581704417019",
    // menu:"https://menu.refresh.co.il/",
    menu:"https://menu.refresh.co.il",
    waze: "",
};

export const schedule = {
    link:"https://.com",
    title:"קביעת פגישה אונליין",
}

export const footer = {
    desclaimer: "برمجه وتصميم",
    copywrites: "كيوبي ميديا"
}

export const socialAccounts = {
    wsp:`https://api.whatsapp.com/send?phone=${contact.phone}`,
    ig:`http://instagram.com/${contact.ig}`,
    fb:`https://facebook.com/${contact.fb}`,
}